export const CheckBoxCustomStyle = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "transparent" : "transparent",
    height: "56px",
    borderRadius: "100px",
    borderColor: "none",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "initial",
    cursor: "pointer",
    // height: "100% !important",
  }),

  menu: (provided) => ({
    ...provided,
    width: "100% !important",
    cursor: "pointer",
  }),

  input: (provided) => ({
    ...provided,
    border: "none",
    borderBottom: "none",
    cursor: "pointer",
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "transparent" : "transparent",
  }),
  multiValue: (provided, state) => ({
    ...provided,
    backgroundColor: state.data.isFixed ? "transparent" : "transparent",
    // "::after": {
    //   content:
    //     state.selectProps.value.length === 1
    //       ? '""'
    //       : state.selectProps.value.length === state.data.index + 1
    //       ? '" "'
    //       : '" ,"',
    // },
    color: "#999",
    fontSize: "15px",
    cursor: "pointer",
  }),
  groupHeading: (provided) => ({
    ...provided,
    color: "#333",
    fontSize: "18px",
    fontWeight: "bold",
    cursor: "pointer",
  }),
  multiValueLabel: (provided, state) => {
    return {
      ...provided,
      color: "#999",
      fontSize: "15px",
      cursor: "pointer",
    };
  },

  multiValueRemove: (provided) => ({
    ...provided,
    cursor: "pointer",
  }),
};
